import { LoadableLazy } from '@confluence/loadable';
export { PageLabelsAutomationDiscovery } from '../src/PageLabelsAutomationDiscovery';
export const LazyPageLabelsAutomationDiscovery = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageLabelsAutomationDiscovery" */ '../src/PageLabelsAutomationDiscovery'
			)
		).PageLabelsAutomationDiscovery,
});
